import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { teamVacationRequestMapper } from '../utils/mappers/teamVacationRequestMapper';
import { ColorCodedEmployee } from 'src/components/Timeoff/widgets/TeamWidget/TeamWidgetSection';

export interface TeamVacationData {
  name: string;
  employeeId: string;
  startDate: string;
  endDate: string;
}

export interface TeamRequest {
  ['@odata.etag']: string;
  _new_employee_value: string;
  new_startdate: string;
  new_enddate: string;
  new_axsvacationrequestid: string;
}

export const useGetTeamRequests = (
  team: Array<ColorCodedEmployee>,
  year: number
) => {
  const [requests, setRequests] = useState<Array<TeamVacationData>>([]);
  const initialRender = useRef(true);

  const getUserRequests = async () => {
    try {
      const params = team
        .map((member) => `ids[]=${member.new_employeeid}`)
        .join('&');
      const { data } = await axios.get(
        `api/vacation-requests/team/${year}?${params}`
      );
      const mappedVacationRequests = teamVacationRequestMapper(data, team);
      setRequests(mappedVacationRequests);
    } catch (error) {
      setRequests([]);
      console.error(error);
    }
  };

  const setTeamIdsCache = async () => {
    try {
      const idsParam = team
        .map((team) => `ids[]=${team.new_employeeid}`)
        .join('&');
      await axios.get(`api/employees/set-team-cache?${idsParam}`);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }
    setTeamIdsCache();
  }, [team]);

  useEffect(() => {
    if (team.length > 0) {
      getUserRequests();
    } else {
      setRequests([]);
    }
  }, [year, team]);

  return { requests };
};
